import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-install-01': 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20app%20download%20screen%20with%20download%20button%2C%20clean%20minimal%20interface%20design%2C%20warm%20ambient%20lighting%2C%20modern%20mobile%20device%20on%20wooden%20desk%2C%20soft%20shadows%2C%20editorial%20photography%2C%20cozy%20workspace%20atmosphere&width=800&height=480&seq=article-install-01&orientation=landscape',
  'article-tips-01': 'https://readdy.ai/api/search-image?query=Person%20holding%20smartphone%20watching%20video%20content%20on%20couch%2C%20warm%20living%20room%20atmosphere%2C%20cozy%20evening%20lighting%2C%20relaxed%20lifestyle%20scene%2C%20minimalist%20interior%20design%2C%20soft%20ambient%20glow%2C%20editorial%20photography%20style&width=800&height=480&seq=article-tips-01&orientation=landscape',
  'article-features-01': 'https://readdy.ai/api/search-image?query=Modern%20digital%20tablet%20displaying%20video%20streaming%20interface%20with%20colorful%20thumbnails%2C%20clean%20UI%20design%2C%20warm%20studio%20lighting%2C%20technology%20concept%2C%20minimalist%20composition%2C%20professional%20product%20photography&width=800&height=480&seq=article-features-01&orientation=landscape',
};

export default function ArticlesSection() {
  const featuredArticles = articles.slice(0, 3);

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-sm font-medium rounded-full mb-4">
            <i className="ri-article-line mr-1"></i>
            使用指南
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            快速上手，轻松掌握
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            从下载安装到使用技巧，手把手教你成为爱液视频达人
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredArticles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-all duration-300 cursor-pointer animate-fade-in-up"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={articleImages[article.imageSeq]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="text-foreground-950 font-heading font-semibold text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span><i className="ri-eye-line mr-1"></i>{article.views.toLocaleString()}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/article/aiye-video-app-shiyong-jiqiao"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-500 text-background-50 rounded-full text-sm font-medium hover:bg-secondary-600 transition-all duration-300 cursor-pointer"
          >
            查看更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}